import http from "../plugins/http"

export const fetchRoles = async ({ query = "?all=1" }: { query?: string } = {}) => {
  const data = await http.get(`/v1/roles`)
  return data
}
